export default __webpack_public_path__ + "static/media/MarketLync-Introduction.8173aac4.mp4";